import { Node, Point } from '@/types';

export const isCompressor = (node: Node, points: Record<string, Point>) => {
  return node.points.some((pointId) => points[pointId]?.loc_type_ind === 'COM');
};
